interface StrategistLoadingStateProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  detail?: string | null;
}

export function StrategistLoadingState({
  eyebrow,
  title,
  subtitle,
  detail = null,
}: StrategistLoadingStateProps) {
  return (
    <section className="strategist-loading-state" aria-live="polite" aria-busy="true">
      <div className="strategist-loading-shell">
        <div className="strategist-loading-spinner" aria-hidden="true">
          <span className="strategist-loading-ring strategist-loading-ring-outer" />
          <span className="strategist-loading-ring strategist-loading-ring-inner" />
          <span className="strategist-loading-core">
            <span className="strategist-loading-core-line" />
          </span>
        </div>

        <div className="strategist-loading-copy">
          <span className="strategist-loading-eyebrow">{eyebrow}</span>
          <h2 className="strategist-loading-title">{title}</h2>
          <p className="strategist-loading-subtitle">{subtitle}</p>
          {detail ? <p className="strategist-loading-detail">{detail}</p> : null}
        </div>
      </div>
    </section>
  );
}
